import './App.css';
import { useState } from 'react';

import Loader from './pages/Loader';
import Menu from './pages/Menu';
import ChapterSelectionModal from './components/ChapterSelectionModal';
import usePages from './usePages';
import { PAGES } from './chapterRegistry';
import { shortSteps } from './editorial/model';

const TEST_MODE = false;

function RhythmNote() {
  if (!window.location.search.includes('ritmo=1')) return null;
  const steps = shortSteps();

  return (
    <aside className="rhythm-note">
      <strong>Roteiro da pausa</strong>
      <p>Leia em voz alta e observe a espera depois de cada trecho curto, antes do próximo aparecer.</p>
      <ol>
        {steps.map((step, index) => (
          <li key={`${step.chapter}-${index}`}>
            {step.title}: “{step.spoken}” ({step.words})
          </li>
        ))}
      </ol>
    </aside>
  );
}

function App() {
  const [showChapterSelectionModal, setShowChapterSelectionModal] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const {
    isMobile,
    currentPage,
    currentPageName,
    onNextPage,
    onPreviousPage,
    onResetPages,
    goToPage,
    transcription,
    setTranscription,
    chapterComplete,
    setChapterComplete,
    chapterStart,
    setChapterStart,
  } = usePages({ pages: PAGES });

  const sharedProps = {
    isMobile,
    pageName: currentPageName,
    onNextPage,
    onPreviousPage,
    onResetPages,
    transcription,
    setChapterComplete,
    setChapterStart,
    testMode: TEST_MODE,
    isTransitioning,
    setIsTransitioning,
  };

  const CurrentComponent = currentPage?.Component;

  return (
    <>
      {CurrentComponent ? <CurrentComponent key={currentPageName} {...sharedProps} /> : <Loader />}
      <Menu
        currentPageName={currentPageName}
        setTranscription={setTranscription}
        chapterComplete={chapterComplete}
        chapterStart={chapterStart}
        setChapterComplete={setChapterComplete}
        onResetPages={onResetPages}
        testMode={TEST_MODE}
        onOpenChapterSelection={() => setShowChapterSelectionModal(true)}
      />
      {showChapterSelectionModal && (
        <ChapterSelectionModal
          currentPageName={currentPageName}
          onClose={() => setShowChapterSelectionModal(false)}
          setChapterComplete={setChapterComplete}
          setIsTransitioning={setIsTransitioning}
          goToPage={goToPage}
        />
      )}
      <RhythmNote />
    </>
  );
}

export default App;
